import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.js";


import styles from "assets/jss/material-kit-react/views/components.js";
import TeamSection from "./Sections/TeamSection";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

export default function Contact(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        brand="INCUBIG"
        to="/"
        rightLinks={<HeaderLinks />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 150,
          color: "white",
        }}
        {...rest}
      />
 
 <Parallax image={require("assets/img/ai.gif").default}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>INCUBIG</h1>
                <h3 className={classes.subtitle}>
                  Don't react to change, know future landscape 
                </h3>
              </div>
              <br/>
              <a href={"https://ai.incubig.org/"}>
              <Button
                  color="danger"
                  size="lg"
                  target="_blank"
                  rel="noopener noreferrer"
                  
              >
                  Get Started
              </Button>
              </a>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)} style={{ textAlign:"center"}}>
        <h4>Contact Us</h4>
        <br/>
        <p><b>You can reach us at</b></p>
        <p>AIC-GIM, Goa, GIM Campus, Sanquelim - 403505</p>
        <p><b>Registered Address</b></p>
        <p>S2, Riddhi Siddhi Apartment, Plot No 82, Sarti Nagar, Jaipur 302019</p>
        <p>If you have any questions, please contact us by email: ankit@incubig.org.</p>
      </div>
      <Footer />
    </div>
  );
}
